var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockPurpleLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6558_1213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99976 10.9998C8.76118 10.9998 10.9998 8.76118 10.9998 5.99976C10.9998 3.23833 8.76118 0.999756 5.99976 0.999756C3.23833 0.999756 0.999756 3.23833 0.999756 5.99976C0.999756 8.76118 3.23833 10.9998 5.99976 10.9998Z",
    stroke: "#855791",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3V6L8 7",
    stroke: "#855791",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6558_1213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockPurpleLight);
export default __webpack_public_path__ + "static/media/clock-purple-light.8dc1053329ebefa100acb8da32273a9d.svg";
export { ForwardRef as ReactComponent };